import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import List from './timetable/List';
import Timetable from './timetable';
import ClassDetails from './timetable/Details';
import BookClass from './timetable/Book';
import Center from './Center';
import IndividualConsultationsTimetable from './individualConsultations';
import BookIndividualConsultation from './individualConsultations/Book';
import Workshops from './workshops';
import WorkshopDetails from './workshops/Details';
import WorkshopSessions from './workshops/Sessions';
import BookWorkshop from './workshops/Book';
import CookiePolicy from '../dashboard/info/CookiePolicy';

class Public extends Component {
	render() {
		return <Switch>
			<Route path='/public/centers' exact component={Center} />
			<Route path='/public/timetable' exact component={this.props.timetableViewType === 'Calendar' ? Timetable : List} />
			<Route path='/public/timetable/:centerId/:programId/wait/:lessonType/:startDate/' exact component={BookClass} />
			<Route path='/public/timetable/:centerId/:programId/book/:lessonType/:startDate/:paymentType/:annualPaymentLength/:isPrepaid/:isBonusLesson' exact component={BookClass} />
			<Route path='/public/timetable/:centerId/:programId' component={ClassDetails} />
			<Route path='/public/individual-consultations' exact component={IndividualConsultationsTimetable} />
			<Route path='/public/individual-consultations/:centerId/book/:date' exact component={BookIndividualConsultation} />
			<Route path='/public/workshops' exact component={Workshops} />
			<Route path='/public/workshops/:centerId/:workshopId' exact component={WorkshopDetails} />
			<Route path='/public/workshops/:centerId/:workshopId/sessions' exact component={WorkshopSessions} />
			<Route path='/public/workshops/:centerId/:workshopId/book' exact component={BookWorkshop} />
			<Route path='/public/cookie-policy' exact component={CookiePolicy} />
		</Switch>;
	}
}
const mapStateToProps = (state) => {
	const { configuration: { franchisor } } = state;

	return {
		timetableViewType: franchisor.timetableViewType
	};
};

export default connect(mapStateToProps, {})(Public);